import { EVocabularyPhraseSaveType, EVocabularyPhraseType, ICaptionsItem } from '../../../../../types/common';
import {
  findVideoPhraseByCaption,
  findVideoPhraseById,
  findVideoPhrasesByType,
  getTargetCaptions,
  getVideoPhraseNoteByPhraseId
} from '../../../../../store/videos/selectors';
import {
  getActiveGroupNativeLanguage, getActiveGroupTargetLanguage,
  getActiveUserGroup,
  getGroupNativeLanguage,
  getGroupTargetLanguage, getNativeLanguage, getTargetLanguage,
  getUserGroupById
} from '../../../../../store/models/selectors';
import { SelectionUtil } from '../../../../../../common/utils/selection-util';
import { SelectionPopupEffects } from '../../../../../effects/selectionPopupEffects';
import { PhraseDetailsEffects } from '../../../../../effects/phrase-details/phrase-details-effects';
import { PhraseListActions } from '../../../../../store/phrase-list/actions';
import { CaptionsSelectionPopupActions } from '../../../../../store/captions-selection-popup/actions';
import { getSelectedNativeCaption, getSelectedTargetCaption } from '../../../../../store/current-video/selectors';
import { batch } from 'react-redux';
import { EShortcutsListenerContainer, setShortcutsListenerContainer } from '../../../../../effects/shortcutsListener';
import {
  IPhraseSelectPreparatorSelectionInfo,
  IPhraseSelectResult,
  PhraseSelectPreparator
} from '../../../../../effects/phrase/utils/phrase-select-preparator';
import { TextSelectionPopupEvents } from '../../../TextSelectionPopup/hocs/events';
import { getDispatch, getState } from '../../../../../store';
import { TextSelectors } from '../../../../../store/text/selectors';
import { PhraseEffects } from '../../../../../effects/phrase/PhraseEffects';
import { getAuthUser, isMainLayoutPhrases2Columns } from '../../../../../store/general/selectors';
import { EPhrasesColumnTab, EUserGroupType } from '../../../../../store/general/types';
import { MainLayoutEffects } from '../../../../../effects/mainLayoutEffects';
import { LangUtil } from '../../../../../../common/utils/lang-util';
import { CaptionsSelectionPopupSelectors } from '../../../../../store/captions-selection-popup/selectors';
import { setCurrentVideoClickedCaptionIndex } from '../../../../../store/current-video/actions';
import { PhraseDetailsActions } from '../../../../../store/phrase-details/actions';
import { PhraseListSelectors } from '../../../../../store/phrase-list/selectors';
import { textSpeaker } from '../../../../../effects/textSpeaker';
import { EPhrasePopupType } from '../../../../../store/phrase-list/types';

export class TargetCaptionsEffects {

  public static selectCaption(
    index: number,
    caption: ICaptionsItem,
    wordIndex: number,
    phraseId?: number,
  ) {
      const state = getState();
      const dispatch = getDispatch();

      const selResult: IPhraseSelectResult = {
        text: caption.text,
        startTime: caption.startTime,
        endTime: caption.endTime,
        startCaptionIndex: index,
        endCaptionIndex: index,
        startPosition: 0,
        endPosition: caption.text.length,
        elementId: `caption-item-${index}`,
      };

      const storyFromTranslatedId = TextSelectors.getTextActiveId(state);
      let phrase = !storyFromTranslatedId && (phraseId
          ? findVideoPhraseById(state, phraseId)
          : findVideoPhraseByCaption(state, index, wordIndex)
      )
      if (phrase) {
        let wordPhraseId = phrase.wordPhraseId;
        if (!wordPhraseId && phraseId) {
          wordPhraseId = phraseId;
          let phraseContext = PhraseListSelectors.findPhraseByWordId(state, wordPhraseId);
          if (phraseContext) phrase = phraseContext;
        }
        
        const group = getUserGroupById(state, phrase.userGroupId);
        if (!group) return;
        const targetLang = getGroupTargetLanguage(state, group);
        if (!targetLang) return;
        const nativeLang = getGroupNativeLanguage(state, group) || getNativeLanguage(getState());
        SelectionUtil.removeWindowSelection();

        let note = getVideoPhraseNoteByPhraseId(state, wordPhraseId || phrase?.id || 0)?.text;
        if (note) {
          note = note.replaceAll(/\n|<p><\/p>|<br\s*\/?>/gm, '').trim();
        }

        batch(() => {
          SelectionPopupEffects.dismissSelectText();
          dispatch(PhraseListActions.setTopPhraseId(phrase.id));
          dispatch(PhraseListActions.setPlayCaptionByPhraseId(phrase.id));
          dispatch(CaptionsSelectionPopupActions.setCurrentSelection({contextPhraseId: phrase.id, wordPhraseId}));

          let tab = EPhrasesColumnTab.SAVED;
          if (phrase?.saveType === EVocabularyPhraseSaveType.TRANSLATE) {
            tab = EPhrasesColumnTab.TRANSLATED;
          }
          MainLayoutEffects.setPhrasesColumnTab(tab);
          if (note) {
            PhraseDetailsEffects.showNoteFromSavedPhrase(targetLang, nativeLang, nativeLang, phrase.highlighted, phrase);
            dispatch(PhraseListActions.setPhrasePopup(null as any));
          } else {
            PhraseDetailsEffects.showFromSavedPhrase(targetLang, nativeLang, nativeLang, phrase.highlighted, phrase, EPhrasePopupType.CAPTIONS);
          }
        });

        PhraseEffects.seekPhrase(phrase);
        if (phraseId) {
          selResult.text = phrase.highlighted;
          selResult.startTime = phrase.startTime;
          selResult.endTime = phrase.endTime
          selResult.startCaptionIndex = phrase.startCaptionIndex;
          selResult.endCaptionIndex = phrase.endCaptionIndex;
          selResult.startPosition = phrase.startPosition;
          selResult.endPosition = phrase.endPosition;
          selResult.insideWordActiveId = phraseId;
        }

      } else {
        const targetLang = getSelectedTargetCaption(state);
        const nativeLang = getSelectedNativeCaption(state) || getNativeLanguage(state);
        const activeGroupNativeLang = getActiveGroupNativeLanguage(state);
        PhraseDetailsEffects.showFromCaption(index, targetLang, nativeLang, activeGroupNativeLang, caption);
        batch(() => {
          dispatch(PhraseListActions.setPlayCaptionByPhraseId(0));
          dispatch(PhraseListActions.setCurrentPhraseId(0));
          dispatch(PhraseListActions.setPlayPhraseId(0));
          dispatch(PhraseListActions.setPhrasePopup(EPhrasePopupType.CAPTIONS));
        })
        SelectionUtil.removeWindowSelection();
        SelectionPopupEffects.dismissSelectText();
        dispatch(CaptionsSelectionPopupActions.setCurrentSelection({
          captionIndex: index,
          startTime: caption.startTime,
          endTime: caption.endTime
        }));
      }
      setShortcutsListenerContainer(EShortcutsListenerContainer.CAPTIONS);

      batch(() => {
        dispatch(TextSelectionPopupEvents.onPreviewPhrase(selResult));
        dispatch(CaptionsSelectionPopupActions.setShow(true));
        dispatch(CaptionsSelectionPopupActions.setSelectResult(selResult));
      })

      if (selResult?.text && CaptionsSelectionPopupSelectors.getAutoSpeechText(state)) {
        this.speechText(selResult.text, false);
      }

    }

  public static async runSelectText(selection: Selection, selectionInfo: IPhraseSelectPreparatorSelectionInfo | null,
                                    elementId: string, isSelectPopup: boolean, savePreviewPhrase: boolean,
                                    onPause: () => Promise<any>): Promise<boolean> {
    const state = getState();
    const dispatch = getDispatch();

    const storyFromTranslatedId = TextSelectors.getTextActiveId(state);
    const targetLanguage = getSelectedTargetCaption(state);
    const nativeLanguage = getSelectedNativeCaption(state) || getNativeLanguage(state);

    const wordSelectPhrases = storyFromTranslatedId ? [] : findVideoPhrasesByType(state, EVocabularyPhraseType.WORD_SELECTED);
    const contextPhrases = storyFromTranslatedId ? [] : findVideoPhrasesByType(state, EVocabularyPhraseType.WORD_AND_CONTEXT_SELECTED);
    const useCheckSpanWords = !LangUtil.isHieroglyphLang(targetLanguage?.code || '');
    const selResult = new PhraseSelectPreparator(selection, selectionInfo, getTargetCaptions(state), wordSelectPhrases, contextPhrases, elementId, useCheckSpanWords).execute();

    const selectResultPrev = CaptionsSelectionPopupSelectors.getSelectResult(state);
    if (selResult && selectResultPrev &&
      selResult.text === selectResultPrev.text &&
      selResult.startTime === selectResultPrev.startTime
    ) {
      return false; // no change
    }

    batch(() => {
      dispatch(CaptionsSelectionPopupActions.setShow(true));
      if (selection)
        dispatch(CaptionsSelectionPopupActions.setSelection(selection));
      dispatch(CaptionsSelectionPopupActions.setSelectResult(selResult));
      dispatch(setCurrentVideoClickedCaptionIndex(-1));
      dispatch(PhraseListActions.setPlayCaptionByPhraseId(0));
      dispatch(PhraseListActions.setCurrentPhraseId(0));
      dispatch(PhraseListActions.setPlayPhraseId(0));
      dispatch(PhraseDetailsActions.disActivate());

      if (selResult && isSelectPopup) {
        dispatch(TextSelectionPopupEvents.onPreviewPhrase(selResult));
      } else {
        if (selResult?.externalContextPhrase && selResult.insideWordPhrases && selResult.insideWordPhrases.length) {
          dispatch(CaptionsSelectionPopupActions.setCurrentSelection({
            contextPhraseId: selResult.externalContextPhrase.id,
            wordPhraseId: selResult.insideWordPhrases[0].id,
          }));
        }
      }
    })

    if (targetLanguage && selResult?.text) {
      if (selResult.text) {
        const activeGroupNativeLang = getActiveGroupNativeLanguage(state);
        if (selResult.insideWordActiveId) {
          PhraseDetailsEffects.showFromPhrase(targetLanguage, nativeLanguage, activeGroupNativeLang,
            selResult.insideWordActiveId, selResult.text);
        } else {
          PhraseDetailsEffects.showFromSelectText(targetLanguage, nativeLanguage, activeGroupNativeLang, selResult);
        }

        if (savePreviewPhrase && !getAuthUser(state)?.teacherMode) {
          //const group = getActiveUserGroup(state);
          let phrase;
          if (selResult.insideWordPhrases && selResult.insideWordPhrases.length) {
            phrase = selResult.insideWordPhrases.find(p => p.highlighted === selResult.text);
          }
          if (!phrase && !storyFromTranslatedId) {
            await PhraseEffects.runSavePreviewPhrase(selResult);
            PhraseEffects.flashTab(EVocabularyPhraseSaveType.TRANSLATE);
          }
        }
        if (CaptionsSelectionPopupSelectors.getAutoSpeechText(state)) {
          this.speechText(selResult.text, false);
        }
        await onPause();
      }
    }

    dispatch(PhraseListActions.setPhrasePopup(EPhrasePopupType.CAPTIONS));

    return true;
  }

  private static speechText(text: string, stopOnPlay: boolean) {
    const state = getState();
    if (!CaptionsSelectionPopupSelectors.getAutoSpeechText(state)) return;

    const targetLanguage = getSelectedTargetCaption(state) || getTargetLanguage(state);
    const lang = LangUtil.checkLangCode(targetLanguage?.code || '');
    //TextSelectionPopupUtils.getSpeechTextFromSelect(selectResult);
    const priorityLang = getActiveGroupTargetLanguage(state)?.code;
    textSpeaker.speak(text, lang, stopOnPlay, null, priorityLang);
  }
}